import { Component } from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { ColumnApi, GridApi, GridReadyEvent } from 'ag-grid-community';
import { IApplicationState, AppActionCreators, IVoucherHolderForListResponse, AdpDonorActionCreators, IAppState, IVoucherHolderFileUploadResponse, IBasicCenterListResponse, CenterActionCreators } from '@nkr/store/index';
import { IBaseResponse, ICenterBase, IVoucherHolderForList } from '@nkr/models/index';
import { VoucherHolderAction } from '../voucher-holder-action';
import { toast } from 'react-toastify';
import CenterVoucherHolderList from './center-list';
import AdminVoucherHolderList from './admin-list';
import Search from './search';
import UploadModal from '../modals/upload-modal';
import OrderKitConfirmationModal from '../modals/order-kit-confirmation-modal';
import SwapDonorsNav from '@nkr/views/donors/swap-donors/nav';
import { Alert } from 'react-bootstrap';
import RecipientsNav from '@nkr/views/recipients/tabs';
import { downloadFile } from '@nkr/services/download-file';

interface IProps {
    centerId: number,
    isAdmin: boolean,
    isAdminLogin: boolean,
    donorId?: number
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getVoucherHoldersByCenter: (centerId: number, donorId: number, isAvailable: boolean, firstName: string, lastName: string, alias: string, email: string) => Promise<IVoucherHolderForListResponse>,
    getBasicCenterList: () => Promise<IBasicCenterListResponse>,
    uploadVoucherHolderConsentForm: (voucherHolderId: number, consentFile: File) => Promise<IVoucherHolderFileUploadResponse>,
    uploadVoucherHolderSwabResults: (voucherHolderId: number, swabResultsFile: File) => Promise<IVoucherHolderFileUploadResponse>,
    uploadVoucherHolderScreeningResults: (voucherHolderId: number, screeningResultsFile: File) => Promise<IVoucherHolderFileUploadResponse>,
    resendLink: (voucherHolderid: number) => Promise<IBaseResponse>,
    orderHlaKit: (voucherHolderId: number) => Promise<IBaseResponse>,
    reorderScreening: (voucherHolderId: number) => Promise<IBaseResponse>,
    downloadVoucherHolderDocument: (voucherHolderId: number, docType: number) => Promise<any>,
}

type TProps = IStateProps & IDispatchProps & IProps;

interface IState {
    list: IVoucherHolderForList[],
    center: number,
    status: number, // 0 - available, 1 - unavailable, -1 - both
    firstName: string,
    lastName: string,
    alias: string,
    email: string,
    upload: {
        show: boolean,
        data: IVoucherHolderForList,
        type: VoucherHolderAction
    },
    orderKit: {
        show: boolean,
        data: IVoucherHolderForList,
        type: VoucherHolderAction
    },
    donorAlias: string,
    centerList: ICenterBase[],
    loading: boolean
}

class VoucherHolders extends Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        center: this.props.centerId,
        status: 0,
        firstName: '',
        lastName: '',
        alias: '',
        email: '',
        upload: {
            show: false,
            data: null,
            type: VoucherHolderAction.Unknown
        },
        orderKit: {
            show: false,
            data: null,
            type: VoucherHolderAction.Unknown
        },
        donorAlias: '',
        centerList: [],
        loading: true
    }

    gridApi: GridApi;
    columnApi: ColumnApi;

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.columnApi = e.columnApi;
    }

    componentDidMount = () => {
        this.getData(false);
    }

    getData = async (refresh: boolean) => {
        let urlParams = new URLSearchParams(window.location.search);
        let center = this.state.center;
        let status = 0;
        let firstName = '';
        let lastName = '';
        let alias = '';
        let email = '';

        let centerList = [];

        if (urlParams.has('center')) {
            center = parseInt(urlParams.get('center'));
        }

        if (urlParams.has('status')) {
            status = parseInt(urlParams.get('status'));
        }

        if (urlParams.has('firstName')) {
            firstName = urlParams.get('firstName');
        }

        if (urlParams.has('lastName')) {
            lastName = urlParams.get('lastName');
        }

        if (urlParams.has('alias')) {
            alias = urlParams.get('alias');
        }

        if (urlParams.has('email')) {
            email = urlParams.get('email');
        }

        let isAvailable = status == -1 ? null : (status == 0);

        await this.props.showLoading('Getting voucher holders, one moment please...');

        let response = await this.props.getVoucherHoldersByCenter(center, this.props.donorId, isAvailable, firstName, lastName, alias, email);

        if (this.props.isAdmin) {
            let centerListResponse = await this.props.getBasicCenterList();

            if (centerListResponse.data.success) {
                centerList = centerListResponse.data.results;
            }
        }

        if (response.data.success) {
            let { list, donorAlias } = response.data.results;

            this.setState({
                list,
                status,
                firstName,
                lastName,
                alias,
                donorAlias,
                centerList,
                loading: false
            }, () => {
                if (refresh) {
                    this.gridApi.refreshCells({ force: true });
                }
            });
        }

        this.props.hideLoading();
    }

    handleAction = (voucherHolderId: number, action: VoucherHolderAction) => {
        if (action == VoucherHolderAction.ResendLink) {
            this.handleResendLink(voucherHolderId);    
        }

        if (action == VoucherHolderAction.OrderBuccalSwabKit || action == VoucherHolderAction.OrderLabScreening || action == VoucherHolderAction.ReorderLabScreening) {
            let data = this.state.list.find(x => x.id == voucherHolderId);

            this.setState({
                orderKit: {
                    show: true,
                    data,
                    type: action
                }
            });
        }

        if (action == VoucherHolderAction.UploadVoucherConsent || action == VoucherHolderAction.UploadSwabResults || action == VoucherHolderAction.UploadScreeningResults) {
            let data = this.state.list.find(x => x.id == voucherHolderId);

            this.setState({
                upload: {
                    show: true,
                    data,
                    type: action
                }
            });
        }
    }

    handleResendLink = (id: number) => {
        this.props.showLoading("One moment please, resending voucher holder their registration")
            .then(() => {
                this.props.resendLink(id).then((request) => {
                    let { success, message } = request.data;

                    if (success) {
                        toast.success(message);
                    } else {
                        toast.error('Unable to resend link: ' + message);
                    }
                })
            })
        .finally(() => {
            this.props.hideLoading();
        })
    }

    handleUpdateSearch = (center: number, status: number, firstName: string, lastName: string, alias: string, email: string) => {
        this.setState({
            center,
            status,
            firstName,
            lastName,
            alias,
            email
        });
    }

    handleSearch = () => {
        let { status, firstName, lastName, alias, email } = this.state;
        let { hostname, protocol, port } = window.location;

        let newUrl = '';

        if (this.props.isAdmin) {
            newUrl = `${protocol}//${hostname}:${port}/admin/recipients/voucher-holders?center=${this.state.center}&status=${status}&firstName=${firstName}&lastName=${lastName}&alias=${alias}&email=${email}`;
        } else {
            newUrl = `${protocol}//${hostname}:${port}/center/${this.state.center}/recipients/voucher-holders?status=${status}&firstName=${firstName}&lastName=${lastName}&alias=${alias}&email=${email}&donorId=${this.props.donorId}`;
        }

        window.history.pushState({}, '', newUrl);

        this.getData(true);
    }

    handleReset = () => {
        this.setState({
            status: 0,
            firstName: '',
            lastName: '',
            alias: '',
            email: ''
        }, () => {
            this.handleSearch();
        });
    }

    handleUpload = (file: File) => {
        let { data, type } = this.state.upload;
        let voucherHolderId = data.id;

        this.setState({
            upload: {
                show: false,
                data: null,
                type: VoucherHolderAction.Unknown
            }
        }, () => {
            let success = true;
            let message = '';
            let fileName = '';

            this.props.showLoading('Uploading file, one moment please...').then(async () => {
                if (type == VoucherHolderAction.UploadVoucherConsent) {
                    let response = await this.props.uploadVoucherHolderConsentForm(voucherHolderId, file);

                    success = response.data.success;
                    message = response.data.message;
                    fileName = response.data.results;
                }

                if (type == VoucherHolderAction.UploadSwabResults) {
                    let response = await this.props.uploadVoucherHolderSwabResults(voucherHolderId, file);

                    success = response.data.success;
                    message = response.data.message;
                    fileName = response.data.results;
                }

                if (type == VoucherHolderAction.UploadScreeningResults) {
                    let response = await this.props.uploadVoucherHolderScreeningResults(voucherHolderId, file);

                    success = response.data.success;
                    message = response.data.message;
                    fileName = response.data.results;
                }

                let list = _.cloneDeep(this.state.list).map(item => {
                    if (success && item.id == voucherHolderId) {
                        if (type == VoucherHolderAction.UploadVoucherConsent) {
                            item.adpInformedConsentFile = fileName;
                        }

                        if (type == VoucherHolderAction.UploadSwabResults) {
                            item.hlaSwabResultsFile = fileName;
                        }

                        if (type == VoucherHolderAction.UploadScreeningResults) {
                            item.screeningResultsFile = fileName;
                        }
                    }

                    return item;
                });

                this.setState({
                    list
                }, () => {
                    this.props.hideLoading();

                    if (success) {
                        toast.success('File uploaded successfully');
                    } else {
                        toast.error('Unable to upload file: ' + message);
                    }
                });
            });
        });
    }

    handleCancelUpload = () => {
        this.setState({
            upload: {
                show: false,
                data: null,
                type: VoucherHolderAction.Unknown
            }
        });
    }

    handleOrderKit = () => {
        let { data, type } = this.state.orderKit;
        let voucherHolderId = data.id;

        this.setState({
            orderKit: {
                show: false,
                data: null,
                type: VoucherHolderAction.Unknown
            }
        }, () => {
            let success = true;
            let message = '';

            this.props.showLoading('Submitting kit request, one moment please...').then(async () => {
                if (type == VoucherHolderAction.OrderBuccalSwabKit) {
                    let response = await this.props.orderHlaKit(voucherHolderId);

                    success = response.data.success;
                    message = response.data.message;
                }

                if (type == VoucherHolderAction.OrderLabScreening || type == VoucherHolderAction.ReorderLabScreening) {
                    let response = await this.props.reorderScreening(voucherHolderId)

                    success = response.data.success;
                    message = response.data.message;
                }

                this.props.hideLoading();

                if (success) {
                    toast.success('Kit request submitted successfully');
                } else {
                    toast.error('Unable to request kit: ' + message);
                }
            });
        });
    }

    handleCancelOrderKit = () => {
        this.setState({
            orderKit: {
                show: false,
                data: null,
                type: VoucherHolderAction.Unknown
            }
        });
    }

    handleFileDownload = (voucherHolderId: number, docType: number) => {
        this.props.downloadVoucherHolderDocument(voucherHolderId, docType).then(response => {
            downloadFile(response.data, 'file.pdf', 'application/pdf');
        }).catch(error => {
            toast.error('Unfortunately, that file is not available', { autoClose: false });
        });
    }

    render = () => {
        let donorList = _.uniq(this.state.list.map(x => x.donorId));

        return (
            <>
                {!this.props.isAdmin && (
                    <>
                        {this.props.donorId != null && (
                            <SwapDonorsNav
                                activeKey='VOUCHER-HOLDERS'
                                centerId={this.state.center}
                                donorId={this.props.donorId}
                                donorAlias={this.state.donorAlias}
                                donorIsAdp={true}
                                voucherHolderName={''}
                                recipientId={0}
                                recipientAlias={''}
                                recipientCenterId={0}
                                recipientType={null}
                                isAdminLogin={this.props.isAdminLogin}
                                onTabChange={() => null}
                            />
                        )}

                        <div style={{ width: "100%", paddingBottom: 20, minHeight: "75vh", paddingTop: 0, paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFF" }}>
                            {this.props.donorId != null && (
                                <Alert bsStyle='warning' style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>Voucher Holders must be added BEFORE the donor donates. Voucher holders added after the donation date will not be eligible.</Alert>
                            )}

                            <Search
                                centerId={this.state.center}
                                center={this.state.center}
                                status={this.state.status}
                                firstName={this.state.firstName}
                                lastName={this.state.lastName}
                                alias={this.state.alias}
                                email={this.state.email}
                                isAdmin={false}
                                donorId={this.props.donorId}
                                centerList={this.state.centerList}
                                onUpdateSearch={this.handleUpdateSearch}
                                onSearch={this.handleSearch}
                                onReset={this.handleReset}
                            />

                            <CenterVoucherHolderList
                                isAdminLogin={this.props.app.user.group.isSuper}
                                centerId={this.state.center}
                                list={this.state.list}
                                isLoading={this.state.loading}
                                groupByDonor={this.props.donorId == null}
                                onOrderBuccalSwabKit={(id) => this.handleAction(id, VoucherHolderAction.OrderBuccalSwabKit)}
                                onOrderLabScreening={(id) => this.handleAction(id, VoucherHolderAction.OrderLabScreening)}
                                onReorderLabScreening={(id) => this.handleAction(id, VoucherHolderAction.ReorderLabScreening)}
                                onUploadVoucherConsent={(id) => this.handleAction(id, VoucherHolderAction.UploadVoucherConsent)}
                                onUploadSwabResults={(id) => this.handleAction(id, VoucherHolderAction.UploadSwabResults)}
                                onUploadScreeningResults={(id) => this.handleAction(id, VoucherHolderAction.UploadScreeningResults)}
                                onResendLink={(id) => this.handleAction(id, VoucherHolderAction.ResendLink)}
                                onDownload={this.handleFileDownload}
                                onLoadingComplete={() => null}
                                onGridReady={this.onGridReady}
                            />

                            {this.props.donorId == null ?
                                <div style={{ fontSize: 12 }}>{donorList.length} donor(s) / {this.state.list.length} voucher holder(s)...</div>
                                :
                                <div style={{ fontSize: 12 }}>{this.state.list.length} voucher holder(s)...</div>
                            }
                        </div>
                    </>
                )}

                {this.props.isAdmin && (
                    <div style={{ width: "100%" }}>
                        <RecipientsNav activeKey={'VOUCHER-HOLDERS'} centerId={0} recipientAlias={''} hasRecipientShield={false} isAdmin={true} onTabSelect={function (key: string): void {
                            throw new Error('Function not implemented.');
                        }} />

                        <div style={{ padding: 10, border: '1px solid #ccc', borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }}>
                            <Search
                                centerId={this.state.center}
                                center={this.state.center}
                                status={this.state.status}
                                firstName={this.state.firstName}
                                lastName={this.state.lastName}
                                alias={this.state.alias}
                                email={this.state.email}
                                isAdmin={true}
                                donorId={this.props.donorId}
                                centerList={this.state.centerList}
                                onUpdateSearch={this.handleUpdateSearch}
                                onSearch={this.handleSearch}
                                onReset={this.handleReset}
                            />

                            <AdminVoucherHolderList
                                centerId={this.state.center}
                                list={this.state.list}
                                isLoading={this.state.loading}
                                onOrderBuccalSwabKit={(id) => this.handleAction(id, VoucherHolderAction.OrderBuccalSwabKit)}
                                onOrderLabScreening={(id) => this.handleAction(id, VoucherHolderAction.OrderLabScreening)}
                                onReorderLabScreening={(id) => this.handleAction(id, VoucherHolderAction.ReorderLabScreening)}
                                onUploadVoucherConsent={(id) => this.handleAction(id, VoucherHolderAction.UploadVoucherConsent)}
                                onUploadSwabResults={(id) => this.handleAction(id, VoucherHolderAction.UploadSwabResults)}
                                onUploadScreeningResults={(id) => this.handleAction(id, VoucherHolderAction.UploadScreeningResults)}
                                onResendLink={(id) => this.handleAction(id, VoucherHolderAction.ResendLink)}
                                onDownload={this.handleFileDownload}
                                onLoadingComplete={() => null}
                                onGridReady={this.onGridReady}
                            />

                            <div>{this.state.list.length} voucher holders shown...</div>
                        </div>
                    </div>
                )}

                <UploadModal
                    show={this.state.upload.show}
                    donorAlias={this.state.upload.data != null ? this.state.upload.data.donorAlias : ''}
                    voucherHolderFullName={this.state.upload.data != null ? this.state.upload.data.firstName + ' ' + this.state.upload.data.lastName : ''}
                    type={this.state.upload.type}
                    isDonorProfile={false}
                    onUpload={this.handleUpload}
                    onCancel={this.handleCancelUpload}
                />

                <OrderKitConfirmationModal
                    show={this.state.orderKit.show}
                    donorAlias={this.state.orderKit.data != null ? this.state.orderKit.data.donorAlias : ''}
                    voucherHolderFullName={this.state.orderKit.data != null ? this.state.orderKit.data.firstName + ' ' + this.state.orderKit.data.lastName : ''}
                    type={this.state.orderKit.type}
                    onConfirmed={this.handleOrderKit}
                    onCancel={this.handleCancelOrderKit}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getVoucherHoldersByCenter: (centerId, donorId, isAvailable, firstName, lastName, alias, email) => {
            return dispatch(AdpDonorActionCreators.getVoucherHoldersByCenter(centerId, donorId, isAvailable, firstName, lastName, alias, email));
        },
        getBasicCenterList: () => {
            return dispatch(CenterActionCreators.getBasicCenterList(false));
        },
        uploadVoucherHolderConsentForm: (voucherHolderId, consentFile) => {
            return dispatch(AdpDonorActionCreators.uploadVoucherHolderConsentForm(voucherHolderId, consentFile));
        },
        uploadVoucherHolderSwabResults: (voucherHolderId, swabResultsFile) => {
            return dispatch(AdpDonorActionCreators.uploadVoucherHolderSwabResults(voucherHolderId, swabResultsFile));
        },
        uploadVoucherHolderScreeningResults: (voucherHolderId, screeningResultsFile) => {
            return dispatch(AdpDonorActionCreators.uploadVoucherHolderScreeningResults(voucherHolderId, screeningResultsFile));
        },
        orderHlaKit: (voucherHolderId) => {
            return dispatch(AdpDonorActionCreators.orderHlaKit(voucherHolderId));
        },
        resendLink: (voucherHolderId) => {
            return dispatch(AdpDonorActionCreators.resendVoucherLink(voucherHolderId));
        },
        reorderScreening: (voucherHolderId) => {
            return dispatch(AdpDonorActionCreators.reorderScreening(voucherHolderId));
        },
        downloadVoucherHolderDocument: (voucherHolderId, docType) => {
            return dispatch(AdpDonorActionCreators.downloadVoucherHolderDocument(voucherHolderId, docType));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(VoucherHolders);